import React, { useContext, useEffect, useRef, useState } from 'react';
import { ClickAwayListener, Fade, ListItemIcon, ListItemText, Menu, MenuItem, Popper, Tooltip, Typography } from '@mui/material';
import { SettingsModal } from "./SettingsModal"
import GIcon from '../GIcon';
import JalaliDatePicker from "./jalaiDatePicker"
import SearchPopper from "./searchPoper"
import { useAtomState } from '@zedux/react';
import { selectedFilterAtom, NO_FILTER } from '../../atoms/filterAtoms';
// import "@react-shamsi/calendar/dist/styles.css";
import { FilterTypes, IContext, ITopic } from '../../types';
import DotsIcon from '@src/icons/DotsIcon';
import useModalState from '@src/library/useModalState';


const IconFilterBar = ({ is_admin, topic, context }: { is_admin: boolean, topic: ITopic, context: IContext }) => {


  const [selectedFilter, setSelectedFilter] = useAtomState(selectedFilterAtom, [context, topic.topic_id]);
  const [openMenu, setOpenMenu] = useState(false);
  const [openSearchBar, setOpenSearchBar] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  const [settingsIsOpen, openSettings, closeSettings] = useModalState(false);

  const dotsRef = useRef(null)
  const searchBarAnchor = useRef(null)

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setSelectedFilter({ type: FilterTypes.SEARCH, query: searchQuery });
    setOpenSearchBar(false);
  }


  const iconList = [
    {
      item: <GIcon className={`cursor-pointer p-1 ${selectedFilter.type === FilterTypes.DOCUMENTS ? "bg-info-00 rounded-full text-white" : ""}`} name='description' />,
      label: 'سند',
      onClick: () => { setSelectedFilter({ type: FilterTypes.DOCUMENTS, query: null }); setOpenMenu(false) }
    },
    {
      item: <GIcon className={`cursor-pointer p-1 ${selectedFilter.type === FilterTypes.VIDEO ? "bg-info-00 rounded-full text-white" : ""}`} name='videocam' />,
      label: 'ویدیو',
      onClick: () => { setSelectedFilter({ type: FilterTypes.VIDEO, query: null }); setOpenMenu(false) }
    },
    {
      item: <GIcon className={`cursor-pointer p-1 ${selectedFilter.type === FilterTypes.AUDIO ? "bg-info-00 rounded-full text-white" : ""}`} name='music_note' />,
      label: 'صدا',
      onClick: () => { setSelectedFilter({ type: FilterTypes.AUDIO, query: null }); setOpenMenu(false) }
    },
    {
      item: <GIcon className={`cursor-pointer p-1 ${selectedFilter.type === FilterTypes.IMAGE ? "bg-info-00 rounded-full text-white" : ""}`} name='image' />,
      label: 'تصویر',
      onClick: () => { setSelectedFilter({ type: FilterTypes.IMAGE, query: null }); setOpenMenu(false) }
    },
    {
      item: <GIcon className='cursor-pointer' name='search' />,
      label: 'جستجو',
      onClick: () => { setOpenSearchBar(true); setOpenMenu(false) }
    }
  ]
  // { item: <GIcon className='cursor-pointer' name='person' />, label: 'کاربر', },
  // {
  //   item: <JalaliDatePicker onChange={function (toDate: Date, fromDate?: Date | undefined): void {
  //     if (fromDate == null) {
  //       fromDate = new Date();
  //     }
  //     if (toDate == null) {
  //       toDate = new Date();
  //     }
  //     if (toDate == fromDate) {
  //       return
  //     }
  //     setSelectedFilter({ type: FilterTypes.DATE, query: JSON.stringify({ dateStart: fromDate.getTime(), dateEnd: toDate.getTime() }) });
  //   }} />, label: 'جستجو', onCLick: () => { }
  // },
  // {
  //       item: <SearchPopper setSelectedFilter={setSelectedFilter} />,
  //       label: 'جستجو'
  //     },
  //   ];

  if (is_admin) {
    iconList.push(
      {
        item: <GIcon className='cursor-pointer' onClick={openSettings} name="more_vert"></GIcon>,
        label: 'تنظیمات',
        onClick: openSettings,
      }
    )
  }


  return (
    <div
      className='flex items-center lg:bg-neutral-30 p-1 px-1 py-1 rounded-lg text-[24px] text-stone-500'
      ref={searchBarAnchor}
    >
      <div className="lg:hidden">
        <div className="fill-black stroke-none size-7" ref={dotsRef} onClick={() => setOpenMenu(true)}>
          <DotsIcon />
        </div>
      </div>

      <span className='max-lg:hidden font-normal text-xs'>
        فیلتر پیام‌ها:
      </span>

      <div className='max-lg:hidden flex flex-row items-center'>
        {iconList.map(({ item, label, onClick }, index) => (
          <Tooltip arrow title={label} key={index}>
            <div>
              {React.cloneElement(item, { onClick })}
            </div>
          </Tooltip>
        ))}
        <SettingsModal topic={topic} open={settingsIsOpen} onClose={closeSettings} />

      </div>

      <Menu
        open={openMenu}
        onClose={() => setOpenMenu(false)}
        anchorEl={dotsRef.current}
        disableScrollLock
      >
        {iconList.map(({ item, label, onClick }, index) => (
          <MenuItem onClick={() => { }}>
            <ListItemIcon>{React.cloneElement(item, { onClick })}</ListItemIcon>
            <ListItemText onClick={onClick}><span>{label}</span></ListItemText>
          </MenuItem>
        ))}
      </Menu>
      <Popper className="shadow-md chat-root" open={openSearchBar} anchorEl={searchBarAnchor.current} placement="bottom-start" transition sx={{ zIndex: 2100 }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className="flex flex-row bg-white p-2 border border-stone-400/40">
              <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={() => setOpenSearchBar(false)}>
                <form onSubmit={handleSearch}>
                  <input value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value) }} className="ml-2 border-sky-500" type="text" width={20} />
                  <input type="submit" value="جست و جو" className="bg-sky-500 mr-2 px-4 py-1 rounded text-white cursor-pointer" />
                </form>
              </ClickAwayListener>
            </div>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

export default IconFilterBar;
